import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useThreadList } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadList/useThreadList';
import DataContainer from 'Components/UI/DataContainer';
import {
  ThreadListItem,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadList/components/ThreadListItem';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('ThreadList', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    padding: 0,
  },
  threadList: {
    padding: 0,
    flexGrow: 1,
  },
  mobileRoot: {
    width: '100%',
    border: 'none',
  },
  center: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
  loadMoreButton: {
    padding: theme.spacing(0.5, 2),
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.fontSize1Rem,
    minWidth: 125,
    justifyContent: 'center',
  },
}));

const ThreadList = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const {
    threads,
    selectedThreadResource,
    isSearching,
  } = useMessagesContext();
  const {
    handleThreadClick,
  } = useThreadList();
  const isMobile = useMobileLayout();

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.mobileRoot]: isMobile,
      })}
      {...DataValueMap.init('messages-page-thread-list').build()}
    >
      <List className={classes.threadList}>
        <DataContainer
          className={classes.center}
          loading={isSearching}
          skeleton={() => (
            <Typography variant={'h4'} color={'primaryGray4'} {...DataValueMap.init('thread-list-searching-skeleton').build()}>
              {'Searching...'}
            </Typography>
          )}
        >
          {threads?.map((thread) => (
            <React.Fragment key={thread.id()}>
              <ThreadListItem
                key={thread.id()}
                threadResource={thread}
                selected={selectedThreadResource?.id() === thread.id()}
                onClick={() => handleThreadClick(thread)}
              />
            </React.Fragment>
          ))}
          {threads.length === 0 && (
          <Box className={classes.center}>
            <Typography variant={'h4'} color={'primaryGray4'} {...DataValueMap.init('thread-list-no-threads-found').build()}>
              {'No threads found'}
            </Typography>
          </Box>
          )}
        </DataContainer>
      </List>
    </Box>
  );
};

ThreadList.defaultProps = {
  className: '',
};

ThreadList.propTypes = {
  className: PropTypes.string,
};

export { ThreadList };
